import React from "react";

import { SearchInput } from "../../../../components/Input";
import {
  Toolbar,
  ToolbarCount,
  ToolbarField,
  ToolbarSearch,
  ToolbarSelect,
} from "../../styles";
import { JOB_AGE_OPTIONS, JOB_STATE_OPTIONS } from "../constants";
import { JobAgeFilter, JobStateFilter, JobsToolbarProps } from "../types";

export const JobsToolbar: React.FC<JobsToolbarProps> = ({
  query,
  state,
  age,
  countLabel,
  onQueryChange,
  onStateChange,
  onAgeChange,
}) => {
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    onQueryChange(event.target.value);
  const handleClearSearch = () => onQueryChange("");
  const handleState = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onStateChange(event.target.value as JobStateFilter);
  const handleAge = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onAgeChange(event.target.value as JobAgeFilter);

  return (
    <Toolbar>
      <ToolbarSearch>
        <SearchInput
          aria-label="Search background jobs"
          placeholder="Search symbol, failure, date or user id"
          value={query}
          onChange={handleSearch}
          onClear={handleClearSearch}
        />
      </ToolbarSearch>
      <ToolbarField>
        Job state
        <ToolbarSelect value={state} onChange={handleState}>
          {JOB_STATE_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      <ToolbarField>
        Job age
        <ToolbarSelect value={age} onChange={handleAge}>
          {JOB_AGE_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      {countLabel && <ToolbarCount role="status">{countLabel}</ToolbarCount>}
    </Toolbar>
  );
};
